import { supabase } from "@/integrations/supabase/client";
import { OfferingCreateData } from "@/types/mentorOffering";

/**
 * Send notification to a mentor about a newly created offering
 */
export async function notifyMentorshipCreation(offeringData: OfferingCreateData): Promise<void> {
  console.log("🔔 [notifyMentorshipCreation] Iniciando envio de notificação para mentoria criada");
  console.log("🔔 [notifyMentorshipCreation] Dados da mentoria:", offeringData);
  
  try {
    // First get game name if game_id is provided
    let gameName = "";
    if (offeringData.game_id) {
      console.log("🔔 [notifyMentorshipCreation] Buscando nome do jogo com ID:", offeringData.game_id);
      
      const { data: gameData, error: gameError } = await supabase
        .from("games")
        .select("name")
        .eq("id", offeringData.game_id)
        .single();
      
      if (gameError) {
        console.error("🔔 [notifyMentorshipCreation] Erro ao buscar nome do jogo:", gameError);
      } else {
        gameName = gameData?.name || "";
        console.log("🔔 [notifyMentorshipCreation] Nome do jogo encontrado:", gameName);
      }
    } else {
      console.log("🔔 [notifyMentorshipCreation] Nenhum game_id fornecido");
    }
    
    // Get mentor email from profile
    console.log("🔔 [notifyMentorshipCreation] Buscando dados do mentor...");
    const { data: userData, error: userError } = await supabase.auth.getUser();
    
    if (userError) {
      console.error("🔔 [notifyMentorshipCreation] Erro ao buscar usuário:", userError);
      throw new Error(`Erro ao buscar usuário: ${userError.message}`);
    }
    
    const userId = userData.user?.id;
    console.log("🔔 [notifyMentorshipCreation] User ID:", userId);
    
    if (!userId) {
      throw new Error("Usuário não autenticado");
    }
    
    // Get mentor profile with email
    const { data: profileData, error: profileError } = await supabase
      .from("profiles")
      .select("email, nickname")
      .eq("id", userId)
      .single();
    
    if (profileError) {
      console.error("🔔 [notifyMentorshipCreation] Erro ao buscar perfil:", profileError);
      throw new Error(`Erro ao buscar perfil: ${profileError.message}`);
    }
    
    const mentorEmail = profileData?.email;
    const mentorName = profileData?.nickname || "Mentor";
    console.log("🔔 [notifyMentorshipCreation] Email do mentor:", mentorEmail);
    console.log("🔔 [notifyMentorshipCreation] Nome do mentor:", mentorName);
    
    if (!mentorEmail) {
      throw new Error("Email do mentor não encontrado no perfil");
    }
    
    const emailPayload = {
      to: mentorEmail,
      template: "mentorshipCreated",
      data: {
        title: offeringData.title,
        gameName: gameName,
        durationMinutes: offeringData.duration_minutes,
        priceCents: offeringData.price_cents,
        mentorName: mentorName,
        appUrl: window.location.origin
      }
    };
    
    console.log("🔔 [notifyMentorshipCreation] Enviando email com payload:", emailPayload);
    
    const { data: emailResult, error: emailError } = await supabase.functions.invoke("send-email", {
      body: emailPayload
    });
    
    if (emailError) {
      console.error("🔔 [notifyMentorshipCreation] Erro ao enviar email:", emailError);
      throw new Error(`Erro ao enviar email: ${emailError.message}`);
    }
    
    console.log("🔔 [notifyMentorshipCreation] ✅ Email enviado com sucesso!", emailResult);
    
  } catch (error) {
    console.error("🔔 [notifyMentorshipCreation] ❌ ERRO CRÍTICO no envio de email:", error);
    // Re-throw the error so it's visible to the user
    throw error;
  }
}
